<template>
  <vs-table ref="table" class="pb-5" :data="shippingLabels">
    <template slot="thead">
      <vs-th v-for="(header, index) in headers" :key="`header-${index}`" >
        {{ header }}
      </vs-th>
    </template>

    <template slot-scope="{data}">
      <tbody v-for="(shippingLabel, index) in data" :data="shippingLabels" :key="`shippingLabel-${index}`">
      <vs-tr class="cursor-pointer">
        <vs-td>
          <p class="font-medium truncate">{{ shippingLabel.shippingName }}</p>
        </vs-td>
        <vs-td>
          <p class="font-medium truncate">{{ shippingLabel.shippingMethod }}</p>
        </vs-td>
        <vs-td>
          <p class="font-medium truncate">{{ shippingLabel.trackingNumber }} </p>
        </vs-td>
        <vs-td>
          <p class="font-medium truncate">{{ moment(shippingLabel.shipDate).format('MM-DD-YYYY') }}</p>
        </vs-td>
      </vs-tr>
      </tbody>
    </template>
  </vs-table>
</template>

<script>

import moment from "moment";

export default {
  props: [
    'shippingLabels'
  ],
  data() {
    return {
      headers: ["Shipping Name", "Shipping Method", "Tracking Number", "Ship Date"]
    }
  },
  methods: {
    moment: moment
  }
}
</script>
